import { FC } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { IconButton } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { useGoBack } from '../hooks/router'
import { useDarkMode } from '../contexts/DarkModeContext'

interface GoBackProps {
  variant?: 'filled' | 'outlined' | 'gradient' | 'text'
  color?: colors
}

const GoBack: FC<GoBackProps> = ({ variant, color }) => {
  const goBack = useGoBack()
  const { darkMode } = useDarkMode()
  const iconColor = darkMode ? (color ?? 'white') : (color ?? 'primary')
  return (
    <IconButton
      variant={variant ?? 'text'}
      color={iconColor as colors} // eslint-disable-line @typescript-eslint/no-explicit-any
      onClick={goBack}
    >
      <MdArrowBack className="w-6 h-6" />
    </IconButton>
  )
}

export default GoBack
